var _style, _circle, _circle2, _circle3, _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtForgot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    role: "img",
    "aria-label": "Animated password recovery illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Password recovery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .slip {\n      transform-box: fill-box;\n      animation: rise 5s cubic-bezier(0.34, 1.15, 0.4, 1) infinite;\n    }\n    @keyframes rise {\n      0%, 8%    { transform: translateY(46px); }\n      34%, 74%  { transform: translateY(0); }\n      92%, 100% { transform: translateY(46px); }\n    }\n\n    .halo {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: halo 5s ease-out infinite;\n    }\n    @keyframes halo {\n      0%, 32%   { transform: scale(0.55); opacity: 0; }\n      48%       { transform: scale(1.1);  opacity: 0.45; }\n      64%, 100% { transform: scale(1.45); opacity: 0; }\n    }\n\n    .mote { animation: drift 6s ease-in-out infinite; }\n    .mote-2 { animation-duration: 7.5s; animation-delay: -2s; }\n    .mote-3 { animation-duration: 8.5s; animation-delay: -4s; }\n    @keyframes drift {\n      0%, 100% { transform: translateY(0); opacity: 0.55; }\n      50%      { transform: translateY(-7px); opacity: 1; }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .slip, .halo, .mote { animation: none; }\n      .slip { transform: translateY(0); }\n      .halo { opacity: 0; }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mote",
    cx: 22,
    cy: 66,
    r: 3.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-2",
    cx: 180,
    cy: 52,
    r: 4.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-3",
    cx: 174,
    cy: 172,
    r: 3,
    fill: "#ffffff",
    opacity: 0.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 96,
    width: 132,
    height: 72,
    rx: 14,
    fill: "#eaf3fb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "slip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 52,
    width: 84,
    height: 66,
    rx: 11,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "halo",
    cx: 100,
    cy: 86,
    r: 26,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 79 v-5 a9 9 0 0 1 18 0 v5",
    fill: "none",
    stroke: "#9fc3e6",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 78,
    width: 26,
    height: 21,
    rx: 6,
    fill: "#2b8fe0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 86,
    r: 2.8,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.6,
    y: 87.5,
    width: 2.8,
    height: 6,
    rx: 1.4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 106,
    width: 48,
    height: 5,
    rx: 2.5,
    fill: "#dce6f0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 124 L100 160 L166 124 L166 154 a14 14 0 0 1 -14 14 L48 168 a14 14 0 0 1 -14 -14 Z",
    fill: "#cfe0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtForgot);
export default __webpack_public_path__ + "static/media/art-forgot.e7598a5e5e3d3988131a7d94618cf286.svg";
export { ForwardRef as ReactComponent };